module.exports = __webpack_public_path__ + "c0b137c29e844a280195459043cc2395.mp4";